import { createTheme } from "@mui/material/styles";

const CustomColors = {
	primary: "#2357BE",
	gray: "#666666",
	grayLight: "#B3B3B3",
	grayMedium: "#CCCCCC",
	grayStrong: "#999999",
};

const CustomTheme = createTheme({
	typography: {
		fontFamily: "Montserrat, sans-serif",
		allVariants: {
			color: CustomColors.gray,
		},
	},
	palette: {
		primary: {
			main: CustomColors.primary,
		},
		text: {
			primary: CustomColors.gray,
			secondary: CustomColors.gray,
			disabled: CustomColors.grayMedium,
		},
        action: {
            disabled: "#FFFFFF",
            disabledBackground: `#CCCCCC`,
        },
	},
});

export { CustomTheme, CustomColors };
